import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MODAL_TYPE_UNFOLLOW_MEMBER } from '../../constants/modal-types';
import { openModal } from '../../actions/open-modal';
import { toggleUserSubscribe } from '../../actions/toggle-user-subscribe';
import FollowUserButtonMobile from '../../components/follow-user-button-mobile';
import ensureAuth from '../../hoc/ensure-auth';

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      onClick: () =>
        ownProps.user.isSubscribed ?
          openModal(MODAL_TYPE_UNFOLLOW_MEMBER, { userId: ownProps.user._id }) :
          toggleUserSubscribe(ownProps.user._id),
    },
    dispatch
  );

export default _.flowRight(connect(undefined, mapDispatchToProps), ensureAuth)(FollowUserButtonMobile);



// WEBPACK FOOTER //
// ./app/containers/follow-user-button-mobile-secure/follow-user-button-mobile-secure.js